// React
import React from "react";
import { Routes, Route } from "react-router-dom";

// Components
import NavigationBar from "Components/Users/Patient/NavigationBar";
import Appointments from "../Appointments";
import PatientForm from "Components/PatientForm";
import UpcomingPastAppointments from "../UpcomingPastAppointments";
import PatientHome from "../PatientHome";
import ChangePassword from "Components/ChangePassword";

// MUI
import { Box } from "@mui/material";

// Styles
import { styles } from "./styles";

const PatientPortal = () => {
  return (
    <Box sx={styles.background}>
      <NavigationBar />
      <Routes>
        <Route path="/" element={<PatientHome />} />
        <Route path="/Appointments" element={<Appointments />} />
        <Route
          path="/AppointmentManagement"
          element={<UpcomingPastAppointments />}
        />
        <Route path="/PatientForm" element={<PatientForm />} />
        <Route path="/ChangePassword" element={<ChangePassword />} />
      </Routes>
    </Box>
  );
};

export default PatientPortal;
